import React from "react"

const SvgPlus = (props) => (
  <svg viewBox="0 0 10 10" {...props}>
    <path d="M6 0v4h4v2H6v4H4V6H0V4h4V0h2z" fillRule="evenodd" />
  </svg>
)

export default SvgPlus
